import { all, fork } from "redux-saga/effects";
import loginSaga from "./auth/saga";
import profileSaga from "./profile/saga";

export function* rootSaga() {
  yield all([fork(loginSaga), fork(profileSaga)]);
}
